import React from 'react';
import { useRecordContext } from 'react-admin';

const TextConcatenator = ({ source, attribute }) => {
  const record = useRecordContext();
  if (!record || !record[source] || !record[source].length) return null;

  const concatenatedText = record[source]
    .map(item => item[attribute])
    .join(', ');

  return <span>{concatenatedText}</span>;
};

export default TextConcatenator;
